// 七陌客服（已停用）
// export function qimoChat() {
//   // 容错：先判断全局方法是否存在，避免 JS 报错
//   if (typeof window.qimoChatClick === "function") {
//     window.qimoChatClick(); // 调用七陌的全局方法
//   } else {
//     console.warn("七陌客服 JS 暂未加载");
//   }
// }

export function qimoChat() {
  // 容错：先判断全局方法是否存在，避免 JS 报错
  if (typeof window.$chatwoot !== "undefined") {
    window.$chatwoot.toggle("open");
  } else {
    console.warn("Chatwoot 客服 JS 暂未加载");
  }
}

export default function () {
  if (process.client) {
    (function (d, t) {
      var BASE_URL = "https://kf.juude.cn";
      var g = d.createElement(t),
        s = d.getElementsByTagName(t)[0];
      g.src = BASE_URL + "/packs/js/sdk.js";
      g.async = true;
      s.parentNode.insertBefore(g, s);
      g.onload = function () {
        window.chatwootSDK.run({
          websiteToken: "FeZuyF8JaP9HndotU8AVYEed",
          baseUrl: BASE_URL,
        });
      };
    })(document, "script");
  }
}
